interface Props {
  title: string;
  message: string;
  onClick: () => void;
}

export function StatusToast({ title, message, onClick }: Props) {
  return (
    <button type="button" role="status" className="status-toast" onClick={onClick}>
      <span className="status-toast-title">{title}</span>
      <span>{message}</span>
    </button>
  );
}
